import { groq } from "next-sanity"

import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { groqBranchOfficeProjection } from "../../shared/sanity/branchOffice.projection"

export const queryBranchOffices = {
  async branchOffices(parent, args, context, info) {
    let { offset, limit, sort, lang = AppSettings.defaultLocale(), cdn = true, sortWithinLimits } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.BRANCHES,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    let branchOffices
    branchOffices = await client.fetch(
      groq`{
        "total": count(*[_type=="branchOffice"]),
        "items": *[_type=="branchOffice"  ${draftsFilter}]${pipesAndLimits} {
            ...,
            ${groqBranchOfficeProjection()}
        } 
      }`,
    )

    if (!branchOffices)
      branchOffices = {
        offset,
        limit,
        count: 0,
        total: 0,
        items: [],
      }

    branchOffices = {
      ...branchOffices,
      offset,
      limit,
      count: branchOffices.items.length,
    }

    return branchOffices
  },
}
